import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { List, X } from "@phosphor-icons/react";
import logo from "@/assets/images/UrbNetLogoSemFundo.png";

const navLinks = [
  { label: "Início", href: "https://urbnet.app.br/", external: false },
  { label: "Sou Cidadão", href: "https://urbnet.app.br/sou-cidadao", external: false },
  { label: "Sou Governo", href: "#recursos", external: false },
  { label: "Quem somos", href: "/quem-somos", external: false },
];

export function PublicHeader() {
  const navigate = useNavigate();
  const [mobileListOpen, setMobileListOpen] = useState(false);

  const handleNavClick = (link: { label: string; href: string; external: boolean }) => (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    setMobileListOpen(false);
    if (link.href.startsWith("http")) {
      window.location.href = link.href;
    } else if (link.href === "#") {
      window.scrollTo({ top: 0, behavior: "smooth" });
    } else if (link.href.startsWith("/")) {
      navigate(link.href);
    } else {
      const target = document.querySelector(link.href);
      if (target) {
        target.scrollIntoView({ behavior: "smooth" });
      }
    }
  };

  const goToOrcamento = () => navigate("/solicitar-orcamento");

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-white/40 bg-background/50 backdrop-blur md:backdrop-blur-2xl">
      <div className="relative mx-auto flex h-[72px] max-w-7xl items-center justify-between px-4 md:h-[80px] md:px-6">
        {/* Logo */}
        <a
          href="#"
          onClick={handleNavClick({ label: "Início", href: "https://urbnet.app.br/", external: false })}
          className="flex items-center gap-2 md:gap-3"
        >
          <img src={logo} alt="UrbNet" className="h-9 w-auto md:h-10" />
        </a>

        {/* Center nav */}
        <nav className="hidden items-center gap-8 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              target={link.external ? "_blank" : undefined}
              rel={link.external ? "noopener noreferrer" : undefined}
              onClick={handleNavClick(link)}
              className={`text-sm font-medium transition-colors ${
                link.label === "Sou Governo"
                  ? "text-[#2b6a46] font-bold underline"
                  : "text-muted-foreground hover:text-foreground"
              }`}
            >
              {link.label}
            </a>
          ))}
        </nav>

        {/* Desktop CTA */}
        <button
          onClick={goToOrcamento}
          style={{
            backgroundImage:
              "linear-gradient(135deg, hsl(var(--secondary)) 0%, hsl(var(--primary)) 100%)",
          }}
          className="hidden md:inline-flex items-center gap-2 rounded-full px-5 py-2.5 text-[13px] font-bold uppercase tracking-[0.05em] text-primary-foreground shadow-[0_8px_28px_-10px_hsl(var(--primary)/0.6)] ring-2 ring-white/30 transition-all duration-300 hover:-translate-y-0.5 hover:scale-[1.03] hover:shadow-[0_14px_40px_-12px_hsl(var(--primary)/0.75)] active:translate-y-0 active:scale-[0.98]"
        >
          <span>Solicite orçamento</span>
        </button>

        {/* Mobile menu toggle */}
        <button
          onClick={() => setMobileListOpen((o) => !o)}
          aria-label={mobileListOpen ? "Fechar menu" : "Abrir menu"}
          className="inline-flex h-10 w-10 items-center justify-center rounded-full border border-white/60 bg-white/50 text-foreground shadow-sm backdrop-blur md:hidden"
        >
          {mobileListOpen ? <X className="h-5 w-5" weight="bold" /> : <List className="h-5 w-5" weight="bold" />}
        </button>
      </div>

      {/* Mobile nav */}
      <div
        className={`overflow-hidden border-t border-white/40 bg-background/85 backdrop-blur transition-all duration-300 md:hidden ${
          mobileListOpen ? "max-h-80 opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <nav className="flex flex-col gap-1 px-4 py-4">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              target={link.external ? "_blank" : undefined}
              rel={link.external ? "noopener noreferrer" : undefined}
              onClick={handleNavClick(link)}
              className={`rounded-xl px-4 py-3 text-sm font-medium transition-colors ${
                link.label === "Sou Governo"
                  ? "text-[#2b6a46] font-bold underline"
                  : "text-muted-foreground hover:bg-white/50 hover:text-foreground"
              }`}
            >
              {link.label}
            </a>
          ))}
          <button
            onClick={goToOrcamento}
            className="mt-2 rounded-xl bg-gradient-to-r from-secondary to-primary px-4 py-3 text-[13px] font-bold uppercase tracking-[0.05em] text-primary-foreground transition-all hover:opacity-90"
          >
            Solicite orçamento
          </button>
        </nav>
      </div>
    </header>
  );
}
